export default function recursivlyModifyTree({
  tree, callback, nestingKey = 'children',
}) {
  for (const item of [tree]
    .flat()) {
      if (typeof callback === 'function') {
        callback(item);
      }

      if (!Array.isArray(item[nestingKey])) continue;

      for (const children of item[nestingKey]) {
        recursivlyModifyTree({
          tree: children,
          callback,
          nestingKey,
        });
      }
    }
}
